module.exports = __webpack_public_path__ + "3c97cbe80d1e76afddf990a020a5848f.jpg";